// extracted by mini-css-extract-plugin
module.exports = {"circleLoader":"PhotosWrapper_circleLoader__3Rw3N"};